import { tss } from '@/shared/styles/tss'
import tasksBg from '@/public/assets/temp/tasks/tasks_bg.webp'

export const useStyles = tss.withName('Tasks').create(({ theme }) => ({
  root: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    top: '-40px',
    width: '100%',
    color: theme.colors.text.primary,

    h1: {
      fontSize: theme.sizes.texts.fontSize.xl,

      lineHeight: '40px',
      fontWeight: 500,
    },
  },

  img: {
    position: 'relative',
    width: '100vw',
    top: '20px',
    right: '0px',
    height: '250px',
    backgroundImage: `url(${tasksBg})`,
    backgroundPosition: 'center',
    backgroundSize: '120%',
    zIndex: 0,
  },

  progressBar: {
    marginTop: '6px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },

  circleBarWrapper: {
    display: 'flex',
    alignItems: 'center',
  },

  backgroundImageWrapper: {
    position: 'relative',
  },

  sectionHeading: {
    fontWeight: 370,
    fontSize: '13px',
    lineHeight: theme.sizes.texts.lineHeight.s,

    paddingLeft: '4px',
    textTransform: 'uppercase',
    color: theme.colors.text.secondary,
  },

  descriptionWrapper: {},

  sectionDescription: {
    display: 'inline-block',
    alignSelf: 'center',
    width: '90%',
    fontWeight: 270,
    fontSize: '13px',
    lineHeight: theme.sizes.texts.lineHeight.s,

    paddingLeft: '4px',
    color: theme.colors.text.secondary,
  },

  headingWrapper: {
    position: 'absolute',
    width: '100%',
    top: '40px',
    padding: '0px 30px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  inGameTasksWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },

  taskCountText: {
    display: 'block',
    minWidth: '40px',
    fontWeight: 450,
    fontSize: theme.sizes.texts.fontSize.l,
    lineHeight: theme.sizes.texts.lineHeight.xl,

    textAlign: 'center',
    color: theme.colors.text.secondary,
  },

  tasksListWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    paddingBottom: '7vh',
  },
}))

export const tabListStyles = {
  width: '100%',
  display: 'flex',
  marginTop: '24px',
  padding: 0,
  flexDirection: 'row',
  borderRadius: '8px',
  minHeight: '32px',
  maxHeight: '45px',
  backgroundColor: '#B0B1B81F',
  '.MuiTabs-flexContainer': {
    justifyContent: 'space-between',
    padding: 0,
  },
  button: {
    borderRadius: '7px',
    color: 'white',
    padding: '3px 10px',
    textTransform: 'none',
    width: '50%',
    minHeight: '32px',
    fontFamily: 'Inter',
    fontWeight: '350',
    fontSize: '14px',
    '&.Mui-selected': {
      backgroundColor: '#FFFFFF29',
      color: 'white',
      border: '2px solid rgba(0, 0, 0, 0.5)',
      boxShadow: '0px 3px 8px 0px rgba(0, 0, 0, 0.12), 0px 3px 1px 0px rgba(0, 0, 0, 0.04)',
    },
  },
  span: {
    display: 'none',
  },
}
